import React, { useEffect } from "react";
import "../styles/signout-modal.css";

type Props = {
    open: boolean;
    onConfirm: () => void;   // Yes
    onClose: () => void;     // No / X / backdrop
};

export default function LogoutConfirmModal({ open, onConfirm, onClose }: Props) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => (open && e.key === "Escape" ? onClose() : undefined);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="lo-modal" role="dialog" aria-modal="true" aria-labelledby="lo-title" onClick={onClose}>
            <div className="lo-card" onClick={(e) => e.stopPropagation()}>
                <button className="lo-close" aria-label="Close" onClick={onClose}>×</button>
                <h3 id="lo-title" className="lo-title">Sign out</h3>
                <p className="lo-desc">Just checking, are you sure you want to sign out?</p>
                <div className="lo-actions">
                    <button type="button" className="btn-pill btn-no" onClick={onClose} autoFocus>No</button>
                    <button type="button" className="btn-pill btn-yes" onClick={onConfirm}>Yes</button>
                </div>
            </div>
        </div>
    );
}